/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosIntegrationConfigurationPaginated } from '../../models/pos-integration-configuration-paginated';

export interface PosIntegrationConfigurationsGet$Params {
}

export function posIntegrationConfigurationsGet(http: HttpClient, rootUrl: string, params?: PosIntegrationConfigurationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PosIntegrationConfigurationPaginated>> {
  const rb = new RequestBuilder(rootUrl, posIntegrationConfigurationsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosIntegrationConfigurationPaginated>;
    })
  );
}

posIntegrationConfigurationsGet.PATH = '/pos-integration-configurations';
